import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { KeycloakService } from 'keycloak-angular';

@Injectable({
  providedIn: 'root',
})
export class KeycloakAuthGuard implements CanActivate {

  constructor(private keycloakService: KeycloakService) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    const isLoggedIn = await this.keycloakService.isLoggedIn();

    if (isLoggedIn) {
      return true;
    }

    await this.keycloakService.login({
      redirectUri: window.location.origin + state.url
    });

    return false;
  }
}
